import { Component, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from 'express';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IUserModel } from 'src/app/core/models/masters/user-master.model';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { ValidationsComponent } from 'src/app/shared/validations/validations.component';

@Component({
  selector: 'app-report-view-popup',
  templateUrl: './report-view-popup.component.html',
  styleUrls: ['./report-view-popup.component.css']
})
export class ReportViewPopupComponent {
 local_data: any;
  showPdf = true;
  constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,private ngxUiLoaderService: NgxUiLoaderService) {
    this.local_data = { ...data };
    console.log('pdf',this.local_data);
  
 
  }


 onPdfLoaded(): void {
   // this.isLoading = false;
    this.ngxUiLoaderService.stop();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  //  get pdfSrc() {
  //   return `data:application/pdf;base64,${this.local_data}`;
  // }
}
